import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';

export function RequiredDocumentReason({ actions }: { actions?: ButtonPropsWithLabel[] }) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.waiverRequired.title')}
      message={t('blockingReasons.waiverRequired.message')}
      actions={actions}
    />
  );
}
